import React from 'react';
import { message, Radio, Modal } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const RadioGroup = Radio.Group;

class ExpectHour extends React.Component {
    state = {
        flag: '',
        loading: false,
    }

    hide = () => {
        this.setState({
            flag: '',
        }, () => {
            this.props.hideExpectHour();
        });
    }


    confirmNoticeReadByOne = (noticeId) => {
        const options = {
            method: 'POST',
            url: API_URL.home.confirmNoticeReadByOne,
            data: { noticeId },
            dataType: 'json',
            doneResult: () => {
                this.props.loadData();
                window.dispatchEvent(new CustomEvent('smo:notice-count-refresh'));
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { flag } = this.state;
        const { expectHourParams: { planFteAdjustmentById, setSession } } = this.props;
        if (!flag) {
            message.warning('请选择是否现在就去调整预计工时');
            return;
        }
        this.setState({ loading: true });
        const status = flag == 2 ? 'DELAY' : 'DOWN';
        const options = {
            method: 'POST',
            url: API_URL.notice.dealPlanFteAdjustmentById,
            data: {
                status,
                planFteAdjustmentById,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);

                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    flag != 2 && this.confirmNoticeReadByOne(setSession.noticeId);
                    if (flag == 1) {
                        for (let [k, v] of Object.entries(setSession)) {
                            sessionStorage[k] = v;
                        }
                        location.href = `/#/member/require`;
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleRadioChange = (e) => {
        this.setState({ flag: e.target.value });
    }

    render() {
        const { flag, loading } = this.state;
        const { expectHourParams: { visible } } = this.props;
        const radioStyle = {
            display: 'block',
            height: '24px',
            lineHeight: '24px',
        };

        return (
            <Modal
                title="预计工时调整处理"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="400px"
            >
                <div className="cont-cont" style={{ padding: '20px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{ paddingLeft: 10, lineHeight: '32px', background: '#FAFAFA' }}>是否现在就去调整预计工时?</div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ marginLeft: 24 }}>
                                <RadioGroup value={flag} onChange={e => this.handleRadioChange(e, 'flag')}>
                                    <Radio value={1} style={radioStyle}>是，现在去调整预计工时</Radio>
                                    <Radio value={2} style={radioStyle}>否，请稍后提醒我去调整预计工时</Radio>
                                    <Radio value={3} style={radioStyle}>否，无需调整预计工时，不再提醒</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default ExpectHour;



// WEBPACK FOOTER //
// ./src/components/layout/notice/ExpectHour.js